import WeekDayHeader from './WeekDayHeader';
import CalendarMonth from './CalendarMonth';
import CalendarHeader from './CalendarHeader';
import { useState, CSSProperties, forwardRef } from 'react';
import classnames from 'classnames';

type SingleMonthCalendarProps = {
  initialMonth: Date;
  selectedDate?: Date;
  numOfMonths?: number;
  onSelect?: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  style?: CSSProperties;
  popoverClassName?: string;
};

const SingleMonthCalendar = forwardRef<HTMLDivElement, SingleMonthCalendarProps>(
  (
    { style, initialMonth, selectedDate, onSelect, minDate, maxDate, popoverClassName },
    ref
  ): JSX.Element => {
    const [currentDate, setCurrentDate] = useState<Date>(initialMonth);

    return (
      <div
        ref={ref}
        style={style}
        className={classnames(
          'fixed w-[368px] overflow-hidden rounded-xl border border-gray bg-white p-6',
          popoverClassName ?? 'z-50'
        )}
        role="dialog"
      >
        <CalendarHeader
          currentDate={currentDate}
          onDateChanged={setCurrentDate}
          minDate={minDate}
          maxDate={maxDate}
        />
        <WeekDayHeader className="mb-4" />
        <CalendarMonth
          currentDate={currentDate}
          selectedDate={selectedDate}
          onSelect={onSelect}
          minDate={minDate}
          maxDate={maxDate}
        />
      </div>
    );
  }
);

export default SingleMonthCalendar;
